import { getPubAbbr } from "@revbox/helpers-fe";
import { cookiesKeyNames } from "@revbox/common-fe";
import { useCookiesContext } from "../../../../../contexts/CookiesContext";
import { TaxonomyModule } from "../../../../../modules/taxonomy";

export function NameRenderer({ value }) {
    const {
        cookiesData,
        getPathKey,
    } = useCookiesContext();
    const cookiesPublisherId = cookiesData[getPathKey()]?.[cookiesKeyNames.publisherId];
    const urlParams = new URLSearchParams(window.location.search)
    const publisherId = urlParams.get('pub') || cookiesPublisherId;

    const name = value.split("@")[0];
    const visits = value.split("@")[1];
    const inventory_type = value.split("@")[2];
    const forecasting = value.split("@")[3];

    // DEBUG: Log forecasting value to console
    if (name && forecasting !== undefined) {
        console.log(`[SpecificNameRenderer] ${name}: forecasting="${forecasting}" (type: ${typeof forecasting})`);
    }

    // Check if forecasting is enabled (handle boolean, string, null, and undefined)
    // Show views badge when forecasting is enabled (true or 'true'), hide otherwise
    const isForecastingDisabled = forecasting === 'false' || forecasting === false || forecasting === 'null' || forecasting === null || forecasting === undefined || forecasting === 'undefined';
    const isForecastingEnabled = !isForecastingDisabled;

    if (publisherId != 67 && publisherId != 10) {
        return (
            <div className="d-flex align-items-center table-item-name">
                {name}
                {isForecastingEnabled && (
                    <span className='badge bg-outline-secondary badg m-2'>{visits} Views</span>
                )}
            </div>
        );
    } else {
        return (
            <div className="d-flex align-items-center table-item-name">
                {name}
            </div>
        );
    }
}

export function NameColumnHeaderTooltipRenderer() {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);

    let tooltip = taxonomy.tooltips.ppc_specific_column_headers.name;

    return tooltip; // `Current invetory recived ${visits} visits per last 30 days`;
}

export function NameCellTooltipRenderer({ value }) {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);
    
    const name = value.split("@")[0];
    const visits = value.split("@")[1];

    let tooltip = taxonomy.tooltips.ppc_specific_column_inlines.name;

    return tooltip; // `Current invetory recived ${visits} visits per last 30 days`;
}
 